import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=076351fc"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076351fc')) {
      api.createRecord('076351fc', component.options)
    } else {
      api.reload('076351fc', component.options)
    }
    module.hot.accept("./comment.vue?vue&type=template&id=076351fc", function () {
      api.rerender('076351fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/comment.vue"
export default component.exports